import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SubsidyPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    farmerRegistrationNo: '',
    farmerName: '',
    mobileNumber: '',
    landKhataNo: '',
    landKhesraNo: '',
    landArea: '',
    vanshavali: 'no',
    bankName: '',
    bankBranch: '',
    equipmentName: ''
  });

  const [files, setFiles] = useState({
    landReceiptPhoto: null,
    aadharPhoto: null,
    vanshavaliPhoto: null
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles.length > 0) {
      setFiles(prev => ({ ...prev, [name]: selectedFiles[0] }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const submitData = new FormData();
    Object.keys(formData).forEach(key => {
      submitData.append(key, formData[key] === 'yes' ? true : formData[key] === 'no' ? false : formData[key]);
    });

    if (files.landReceiptPhoto) submitData.append('landReceiptPhoto', files.landReceiptPhoto);
    if (files.aadharPhoto) submitData.append('aadharPhoto', files.aadharPhoto);
    if (files.vanshavaliPhoto) submitData.append('vanshavaliPhoto', files.vanshavaliPhoto);

    try {
      const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');
      const envApiUrl = process.env.REACT_APP_API_URL?.trim();
      const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
      const res = await fetch(`${API_URL}/services/subsidy`, {
        method: 'POST',
        body: submitData
      });
      const data = await res.json();
      if (data.success) {
        setIsSubmitted(true);
      } else {
        alert(data.message || 'Error submitting application.');
      }
    } catch (err) {
      console.error(err);
      alert('Network error while submitting.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="page-container" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header />
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 20px', background: '#f8fafc' }}>
          <div style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', textAlign: 'center', maxWidth: '500px' }}>
            <h2 style={{ color: '#4ba242', marginBottom: '20px' }}>Application Submitted Successfully!</h2>
            <p style={{ color: '#64748b', marginBottom: '30px' }}>Your application for subsidy has been received. Our team will review your details and contact you soon.</p>
            <button onClick={() => window.location.href = '/'} style={{ padding: '12px 24px', background: '#e8762e', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
              Return Home
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ flex: 1, padding: '40px 20px', background: '#f8fafc', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ width: '100%', maxWidth: '700px', marginBottom: '15px' }}>
          <button 
            onClick={() => navigate(-1)} 
            style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#475569', fontWeight: '500', padding: '8px 0' }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            Back
          </button>
        </div>
        <div style={{ width: '100%', maxWidth: '700px', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          <div style={{ background: '#d97706', color: '#fff', padding: '16px', textAlign: 'center' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>Apply for Subsidy</h2>
          </div>
          
          <form onSubmit={handleSubmit} style={{ padding: '30px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Farmer Registration No. / किसान रजिस्ट्रेशन नंबर -</label>
                <input type="text" name="farmerRegistrationNo" required value={formData.farmerRegistrationNo} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>
              
              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Farmer Name / किसान का नाम -</label>
                <input type="text" name="farmerName" required value={formData.farmerName} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Mobile Number / किसान का मोबाइल नंबर -</label>
                <input type="tel" name="mobileNumber" required value={formData.mobileNumber} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Land Khata No. / जमीन रसीद का खाता नंबर -</label>
                <input type="text" name="landKhataNo" required value={formData.landKhataNo} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Land Khesra No. / जमीन रसीद का खेसरा नंबर -</label>
                <input type="text" name="landKhesraNo" required value={formData.landKhesraNo} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Land Area (in Decimal) / जमीन का रकवा (डिसमिल) -</label>
                <input type="text" name="landArea" required value={formData.landArea} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Vanshavali / वंशावली - (Yes/no)</label>
                <select name="vanshavali" value={formData.vanshavali} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }}>
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Bank Name / बैंक का नाम -</label>
                <input type="text" name="bankName" required value={formData.bankName} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Bank Branch Name / बैंक ब्रांच का नाम -</label>
                <input type="text" name="bankBranch" required value={formData.bankBranch} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Equipment Name / कृषि उपकरण का नाम -</label>
                <input type="text" name="equipmentName" required value={formData.equipmentName} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>
              
              <h3 style={{ marginTop: '20px', marginBottom: '10px', fontWeight: 'bold' }}>अपलोड फोटो</h3>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Land Receipt or LPC Photo / जमीन रसीद या एलपीसी का फोटो -</label>
                <input type="file" name="landReceiptPhoto" required accept="image/*,application/pdf" onChange={handleFileChange} style={{ width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Aadhar Card Photo / आधार कार्ड का फोटो -</label>
                <input type="file" name="aadharPhoto" required accept="image/*,application/pdf" onChange={handleFileChange} style={{ width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Vanshavali Photo / वंशावली का फोटो -</label>
                <input type="file" name="vanshavaliPhoto" accept="image/*,application/pdf" onChange={handleFileChange} style={{ width: '100%' }} />
              </div>

              <button type="submit" disabled={isLoading} style={{ background: '#d97706', color: '#fff', padding: '16px', border: 'none', width: '100%', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer', marginTop: '20px' }}>
                {isLoading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SubsidyPage;


